import React from 'react';

import { StockInheritanceTabContent } from 'components/recipes/StockInheritanceTabContent';

import { showAsyncModal } from 'utils/asyncModal';

import { useItemStockInheritanceData } from './sidePane.utils';
import { StockInheritanceInfo } from './StockInheritanceInfo';
import { ViewAllModal } from './ViewAllModal';

export function StockInheritancePanelContent({ itemId, itemUid }: { itemId: string; itemUid: string }) {
  const itemStockInheritanceData = useItemStockInheritanceData(itemUid);

  const openStockInheritanceModal = () => {
    showAsyncModal(StockInheritanceModal, {
      itemId,
      itemUid,
    });
  };

  return (
    <StockInheritanceInfo itemStockInheritanceData={itemStockInheritanceData} onEdit={openStockInheritanceModal} />
  );
}

function StockInheritanceModal({ itemId, itemUid, onClose }: { itemId: string; itemUid: string; onClose: () => void }) {
  const itemStockInheritanceData = useItemStockInheritanceData(itemUid);

  return ViewAllModal({
    title: `Stock Inheritance for Item #${itemId}`,
    content: (
      <StockInheritanceTabContent
        itemStockInheritanceData={itemStockInheritanceData}
        descendantItemId={itemUid}
        descendantItemCode={itemId}
      />
    ),
    onClose,
  });
}
